<template>
  <div>
    <a-card :loading="loading" size="small">
      <a-page-header style="padding: 8px" :title="`${recordData.pipeline_name} 构建详情`" :sub-title="`#${recordData.build_number}`" @back="() => $router.go(-1)">
        <template v-if="recordData.status" slot="tags">
          <a-tag :color="pipelineBuildStatus[recordData.status].color"> {{ pipelineBuildStatus[recordData.status].label }} </a-tag>
        </template>
        <template slot="extra">
          <a-button v-tc="{ name: '重新构建' }" type="primary" size="small" @click="onRebuild"> 重新构建 </a-button>
          <a-button v-tc="{ name: '构建历史' }" size="small" @click="onRecord"> 构建历史 </a-button>
        </template>
        <a-descriptions v-if="loading === false" size="small" :column="3">
          <a-descriptions-item label="服务名称"> {{ recordData.params.app_name }} </a-descriptions-item>
          <a-descriptions-item label="构建人"> {{ recordData.creator.nickname }} </a-descriptions-item>
          <a-descriptions-item label="构建时间"> {{ recordData.created_time }} </a-descriptions-item>
          <a-descriptions-item label="分支"> {{ recordData.branch }} </a-descriptions-item>
          <a-descriptions-item label="持续时间"> {{ recordData.duration }} </a-descriptions-item>
          <a-descriptions-item label="完成时间"> {{ recordData.finish_time }} </a-descriptions-item>
          <a-descriptions-item label="构建产物"> {{ recordData.status === 3 ? recordData.params.image : '--' }} </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
    </a-card>
    <a-card :loading="loading" class="pipeline-process" title="构建过程" size="small">
      <a-button slot="extra" v-tc="{ name: '查看完整日志' }" type="link" @click="onShowLog(index)">查看完整日志</a-button>
      <div v-if="recordData.stages !== null" class="pipeline-process-content">
        <a-steps class="pipeline-process-steps" :style="{ width: `${stagesWidth}px` }">
          <a-step v-for="(stage, index) in recordData.stages" :key="index" :status="stage.status">
            <a-icon v-if="status[stage.status]" slot="icon" :theme="status[stage.status].theme" :type="status[stage.status].icon" :class="status[stage.status].class" />
            <a-icon v-else slot="icon" type="clock-circle" class="step-icon_pending" />
            <div slot="title" v-tc="{ name: '查看日志' }" class="stage-step step-content" @click="onShowLog(stage.id)">
              <a-tooltip placement="topLeft" :title="stage.name">
                <span class="stage-step_title">{{ stage.name }}</span>
              </a-tooltip>
              <span class="stage-step_time">{{ stage.duration }}</span>
            </div>
            <a-timeline slot="description" style="margin-top: 24px; margin-left: -25px">
              <a-timeline-item v-for="(step, timelineIndex) in stage.steps" :key="timelineIndex">
                <a-icon slot="dot" :type="status[step.status].icon" :class="status[step.status].class" />
                <div v-tc="{ name: '查看日志' }" class="stage-step timeline-step" @click="onShowLog(step.id)">
                  <a-tooltip placement="topLeft" :title="step.name">
                    <span class="stage-step_title">{{ step.name }}</span>
                  </a-tooltip>
                  <span class="stage-step_time">{{ step.duration }}</span>
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-step>
        </a-steps>
      </div>
    </a-card>
    <pipeline-build ref="pipelineBuildRef" />
    <pipeline-record ref="pipelineRecordRef" />
    <pipeline-build-log :record-id="recordId" :node-id="nodeId" :visible="logVisible" @close="close" />
  </div>
</template>

<script>
import { pipelineBuildStatus } from '@/utils/dictionary';
import { pipelineRecordDetail } from '@/api/project/pipeline';

import PipelineBuild from '@/pages/project/components/PipelineBuild';
import PipelineRecord from '@/pages/project/components/PipelineRecord';
import PipelineBuildLog from '@/pages/project/components/PipelineBuildLog';

export default {
  components: { PipelineBuildLog, PipelineBuild, PipelineRecord },
  data() {
    return {
      pipelineBuildStatus,
      current: 0,
      loading: true,
      logVisible: false,
      recordId: parseInt(this.$route.query.recordId) || null,
      projectId: parseInt(this.$route.params.project_id) || null,
      nodeId: null,
      recordData: {
        pipeline_name: null
      },
      status: {
        SUCCESS: {
          icon: 'check-circle',
          class: 'step-icon_success',
          theme: 'filled'
        },
        IN_PROGRESS: {
          icon: 'loading',
          class: 'step-icon_loading',
          theme: 'outlined'
        },
        FAILED: {
          icon: 'close-circle',
          class: 'step-icon_error',
          theme: 'outlined'
        },
        ABORTED: {
          icon: 'minus-circle',
          class: 'step-icon_pending',
          theme: 'outlined'
        }
      },
      steps: [
        {
          name: '检出代码',
          node_id: 1,
          icon: 'smile-o',
          description: '980ms',
          status: 'finish'
        },
        {
          name: '单元测试',
          node_id: 1,
          icon: 'smile-o',
          description: '14s',
          status: 'finish'
        },
        {
          name: '编译/构建',
          node_id: 1,
          icon: 'smile-o',
          description: '14s',
          status: 'finish'
        },
        {
          name: '生成镜像',
          node_id: 1,
          icon: 'smile-o',
          description: '14s',
          status: 'error'
        },
        {
          name: '验证镜像',
          node_id: 1,
          icon: 'smile-o',
          description: '14s',
          status: 'In Progress'
        },
        {
          name: '推送镜像',
          node_id: 1,
          icon: 'smile-o',
          description: null,
          status: 'Waiting'
        }
      ]
    };
  },
  computed: {
    stagesWidth() {
      const number = this.recordData.stages !== undefined ? this.recordData.stages.length : 1;
      return number * 300;
    }
  },
  created() {
    if (this.recordId) {
      this.getRocordDetail();
    } else {
      this.$router.push({ name: 'page:project:cicd:pipeline' });
    }
    this.timer = setInterval(() => {
      this.getRocordDetail();
    }, 2000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    close() {
      this.logVisible = false;
    },

    onRecord() {
      this.$nextTick(() => {
        this.$refs.pipelineRecordRef.onOpen({
          pipeline_id: this.recordData.pipeline_id
        });
      });
    },

    onRebuild() {
      this.$nextTick(() => {
        this.$refs.pipelineBuildRef.onOpen({
          branch: this.recordData.branch,
          git_id: this.recordData.params.git_id,
          pipeline_id: this.recordData.pipeline_id
        });
      });
    },

    getRocordDetail() {
      pipelineRecordDetail({ record_id: this.recordId, project_id: this.projectId })
        .then(response => {
          this.recordData = response.data;
          if ([3, 4, 5].includes(this.recordData.status)) {
            clearInterval(this.timer);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(current) {
      this.current = current;
      this.$message.success(current);
    },
    onShowLog(node_id) {
      this.logVisible = true;
      this.nodeId = node_id;
    }
  }
};
</script>

<style lang="less">
.pipeline-stage_card {
  .ant-card-body {
    padding: 0px;
  }
}
</style>

<style lang="less" scoped>
/deep/ .pipeline-process {
  margin-top: 16px;
  width: 100%;
  height: calc(~'100vh - 296px');
  white-space: nowrap; /*文本不会换行，文本会在在同一行上继续*/
  .pipeline-process-content {
    overflow: auto;
    height: calc(~'100vh - 360px');
  }
}
.timeline-step {
  margin-left: 7px;
}
.step-content {
  font-size: 14px;
  font-weight: bold;
}
.stage-step:hover {
  border: 1px solid #1890ff;
  cursor: pointer;
}
.stage-step {
  width: 180px;
  border: 1px solid #dadfe6;
  padding: 0 8px;
  height: 36px;
  .stage-step_title {
    line-height: 36px;
    width: 116px;
    float: left;
    display: -webkit-box; /**对象作为伸缩盒子模型展示**/
    -webkit-box-orient: vertical; /**设置或检索伸缩盒子对象的子元素的排列方式**/
    -webkit-line-clamp: 1; /**显示的行数**/
    overflow: hidden; /**隐藏超出的内容**/
  }
  .stage-step_time {
    float: right;
    width: 46px;
    text-align: right;
    line-height: 36px;
  }
}
.step-icon_success {
  color: #3ac27d;
}
.step-icon_error {
  color: #ff6046;
}
.step-icon_loading {
  color: #1890ff;
}
.step-icon_pending {
  color: #dadfe6;
}
</style>
